import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
